var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7375 4.63379C15.5826 3.78874 16.9537 3.78874 17.7988 4.63379L19.3662 6.20051C20.2113 7.04629 20.2113 8.41743 19.3662 9.26249L9.26303 19.3657C8.85674 19.772 8.30612 20 7.73168 20H4.72166C4.3233 20 4 19.6767 4 19.2783V16.2676C4 15.6939 4.22804 15.1433 4.63433 14.737L14.7375 4.63379ZM16.7784 5.65421C16.4962 5.37277 16.0401 5.37277 15.7579 5.65421L14.4019 7.0102L16.9898 9.59806L18.3458 8.24207C18.6272 7.9599 18.6272 7.50382 18.3458 7.22165L16.7784 5.65421ZM15.9694 10.6185L13.3815 8.03063L5.65476 15.7574C5.51908 15.8931 5.44331 16.0764 5.44331 16.2676V18.5567H7.73168C7.92364 18.5567 8.10694 18.4809 8.24261 18.3452L15.9694 10.6185Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.b72b6fabc809b857d8f4bb43a1c4abd1.svg";
export { ForwardRef as ReactComponent };